$.namespace(
  'MemePlayerController',
  $.Class(function (klass) {
    var MAX_HEIGHT = 120;
    _.assign(this, {
      _currentVolume: 0.7,
      _$player: null,
      _$dot: null,
      _$process: null,
      _mutedVolume: 0,
    });

    this.player = null;

    this.init = function (player, opts) {
      this.player = player;
      this._$player = this.player.$playerSetting;
      this._$process = this._$player.find('.ui-player-volume-bar-process');
      this._$dot = this._$player.find('.ui-player-volume-bar-dot');
      this._$btnMuted = this._$player.find('.ui-player-muted');

      this._currentVolume = opts.volume;
      this._mutedVolume = this._currentVolume || 0.7;

      this.player.log('init control', opts, this._currentVolume);
      this._registerEvent();
      this._updatePosition();

      // if (flvjs.isSupported()) {
      //     $container.find('ui-player-switch').hide();
      // }
    };

    this.setVolume = function (val) {
      this.player.log('setVolume', val);
      this._currentVolume = val;
      this._updatePosition();
      this.player._setVolume(val);
    };

    this.getVolume = function () {
      return this._currentVolume;
    };

    this.setMuted = function () {
      if (this._currentVolume) {
        this._mutedVolume = this._currentVolume;
      }
      this.setVolume(0);
    };
    this.removeMuted = function () {
      this.setVolume(this._mutedVolume || 0.7);
    };

    this._registerEvent = function () {
      var that = this;
      this._$player
        .delegate(
          '.ui-player-volume-bar-dot',
          'mousedown',
          _onMouseDown.bind(this),
        )
        .delegate('.ui-player-muted', 'click', _onSetMuted.bind(this))
        .delegate('.ui-player-switch', 'click', function (e) {
          // data-log 日志事件还没有触发  已经删除了html
          setTimeout(function () {
            that.player.main.switchPlayerType();
          }, 100);
        })
        .delegate('.ui-player-reload', 'click', function (e) {
          that.player.reload();
        })
        .delegate('.ui-player-snapshot', 'click', function (e) {
          var pic = that.player.getSnapshot();
          MM.ui.popup.show({
            title: '截图',
            center: true,
            width: 400,
            content:
              '<div class="text-center"><img style="width:240px;border:solid 1px #f00;" src="data:image/jpeg;base64,' +
              pic +
              '" /></div>',
          });
        });
    };

    this._updatePosition = function () {
      var height = this._currentVolume * MAX_HEIGHT;
      this._$process.height(height);
      this._$dot.css({ bottom: height });

      if (this._currentVolume) {
        this._$btnMuted.attr('title', '静音').removeClass('muted');
      } else {
        this._$btnMuted.attr('title', '取消静音').addClass('muted');
      }
    };

    var startY = 0;
    var startHeight = 0;

    function _onMouseDown(e) {
      startY = e.pageY;
      startHeight = MAX_HEIGHT * this._currentVolume;
      $(document)
        .on('mousemove.playerVolume', _onMouseMove.bind(this))
        .on('mouseup.playerVolume', _onMouseUp.bind(this));
    }

    function _onMouseMove(e) {
      var offsetY = startY - e.pageY;

      var currentY = startHeight + offsetY;

      currentY = currentY < 0 ? 0 : currentY;
      currentY = currentY > MAX_HEIGHT ? MAX_HEIGHT : currentY;

      this._currentVolume = currentY / MAX_HEIGHT;

      this.setVolume(this._currentVolume);
    }

    function _onMouseUp(e) {
      $(document).off('.playerVolume');
    }

    function _onSetMuted(e) {
      var $this = $(e.currentTarget);

      if ($this.hasClass('muted')) {
        this.removeMuted();
      } else {
        this.setMuted();
      }
    }
  }),
);
